import { clinicConfig } from '../config/clinicConfig';

export const defaultFaqs = [
  {
    question: "What conditions can chiropractic care help with?",
    answer: "ActiveRehab evaluates and manages lower and upper back pain, sciatica, neck stiffness, cervicogenic headaches, spondylitis-related discomfort, and posture strain. Dr. Ashok P. Kota customizes every assessment to your individual spinal and joint presentation."
  },
  {
    question: "Can chiropractic care help with sciatica?",
    answer: "Yes. Sciatica involves compression or irritation along the sciatic nerve pathway. Our clinical assessment determines the lumbar or pelvic root cause, using targeted joint mobilizations, pelvic balancing, and decompression protocols to relieve nerve tension."
  },
  {
    question: "What happens during the first consultation?",
    answer: "Your initial visit includes a comprehensive posture analysis, spinal alignment evaluation, joint range of motion testing, and health history review. Dr. Ashok reviews your diagnosis with you and outlines a tailored care plan before initiating care."
  },
  {
    question: "What treatments are available at ActiveRehab?",
    answer: "ActiveRehab combines hands-on chiropractic adjustments, targeted physiotherapy, computerized spinal decompression, posture rehabilitation exercises, and ergonomic guidance to support long-term mobility."
  },
  {
    question: "Do you have clinics in Kondapur and Kompally?",
    answer: "Yes. We operate two fully equipped clinics in Hyderabad: Kondapur (80 Feet Road, above Burfi Ghar) and Kompally (Hale Clinics, Suchitra Road, Opp. Decathlon). Direct care is provided by Dr. Ashok P. Kota at both centers."
  },
  {
    question: "How can I book an appointment or request a callback?",
    answer: `You can submit a callback request using our online form, call our front desk directly at ${clinicConfig.phone}, or message us on WhatsApp. Our team confirms a convenient time slot at your preferred branch.`
  },
  {
    question: "Do I need a doctor's referral before visiting ActiveRehab?",
    answer: "No referral is required. You can schedule a direct consultation with Dr. Ashok P. Kota. If you have previous X-rays, MRI scans, or medical reports, you are encouraged to bring them for review during your initial assessment."
  },
  {
    question: "How do I know whether to choose Kondapur or Kompally?",
    answer: "Choose whichever clinic is closer to your residence or workplace in Hyderabad. Both locations follow identical clinical standards, modern equipment, and direct consultation with Dr. Ashok P. Kota."
  }
];
